import { Component, Event, EventEmitter, getAssetPath, h, Host, Prop } from '@stencil/core';

import wcShared from '@web-components/shared';

@Component({
  tag: 'chat-message-item-list-component',
  styleUrl: 'chat-message-item-list-module.scss',
  shadow: true,
})
export class ModuleChatMessageItemList {
  @Prop() readonly message: IWCChatMessage;

  @Event() openSupportModuleFaq: EventEmitter<IWCFaq>;

  private openFaq(event, item: IWCChatMessageValue) {
    if (item?.type !== 'faq') {
      return;
    }
    event.preventDefault();
    this.openSupportModuleFaq.emit(item?.value);
  }

  render() {
    return (
      <Host>
        <div class="item-list-title">{this.message.title}</div>
        <ul>
          {(this.message?.action as IWCChatMessageValue[])?.map((item) => {
            return (
              <li>
                <a
                  href={item.value}
                  target="_blank"
                  onClick={(event) => this.openFaq(event, item)}
                >
                  {item.label}
                  <img
                    src={getAssetPath('./../assets/icons/chevron-right.svg')}
                    alt={wcShared?.translate('Icon go to link')}
                  />
                </a>
              </li>
            );
          })}
        </ul>
      </Host>
    );
  }
}
